import { ProtectedRestService, RequestOptions } from '@header-footer/bahf-oauthlib-fetch';
import { lastValueFrom } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import { Config } from '../config.i';

// @ts-expect-error   property exists on window, was set earlier
const appConfig: Config = window.__BAFEEDBACKCOMPONENTCONFIG__;

export class ApiService {
  protectedRestService: ProtectedRestService;
  constructor() {
    this.protectedRestService = new ProtectedRestService();
  }

  sendFormWithoutOidc(feedbackClientId: string, message: string, subject: string, rating, additionalInformation?: object) {
    const body = {
      anliegenId: 'h-' + feedbackClientId,
      message: `${message}`,
      subject: `${subject}`,
      rating: `${rating}`,
      additionalInformation,
    };

    const requestOptions: RequestOptions = {
      method: 'PUT',
      body: JSON.stringify(body),
    };

    requestOptions.headers = {
      'Content-Type': 'application/json',
      'Correlation-ID': uuidv4(),
    };

    const config = {
      clientId: 'statistik_internet',
      defaultHeaders: [],
      sessionWarntime: 1770,
      jwtResourceUrl: '/oauth2/rest/authz?client_id=BAPublicClient',
    };

    return lastValueFrom(this.protectedRestService.fetchProtectedResource(appConfig.serviceApi, requestOptions, config));
  }

  sendFormWithOidc(feedbackClientId: string, message: string, subject: string, rating, oidcPublicClientId: string, additionalInformation?: object) {
    const body = {
      anliegenId: 'h-' + feedbackClientId,
      message: `${message}`,
      subject: `${subject}`,
      rating: `${rating}`,
      additionalInformation,
    };

    const requestOptions: RequestOptions = {
      method: 'PUT',
      body: JSON.stringify(body),
    };

    requestOptions.headers = {
      'X-API-Key': oidcPublicClientId,
      'Content-Type': 'application/json',
      'Correlation-ID': uuidv4(),
    };

    return lastValueFrom(this.protectedRestService.fetchProtectedResource(appConfig.serviceApi, requestOptions));
  }
  validateFeedbackConfig(feedbackClientId: string, subject: string, oidcPublicClientId: string, additionalInformation?: number[]) {
    const url = feedbackClientId === undefined ? window.location.href : undefined;
    const body = {
      anliegenId: 'h-' + feedbackClientId,
      subject: `${subject}`,
      additionalInformation,
      url,
    };

    const requestOptions: RequestOptions = {
      method: 'PUT',
      body: JSON.stringify(body),
    };

    requestOptions.headers = {
      'X-API-Key': oidcPublicClientId,
      'Content-Type': 'application/json',
      'Correlation-ID': uuidv4(),
    };

    return lastValueFrom(this.protectedRestService.fetchProtectedResource(appConfig.validateConfigApi, requestOptions));
  }
}
